import { inject, Injectable } from "@angular/core";
import { DataService } from "@core/data";
import { User } from "@domains/user";
import { map, Observable } from "rxjs";
import { SaveUserRequestDto } from "../dtos/request/save-user-request.dto";
import { ClaimDto } from "../dtos/response/claim.dto";
import { UserProfileDto } from "../dtos/response/user-profile.dto";
import { mapClaimsDtoToUser } from "../mappers/claims.mappers";

const USER_ENDPOINT = "/bff/user";
const USER_PROFILE_ENDPOINT = `/api/users/me`;
const USER_SAVE_NAME_ENDPOINT = `/api/users/name`;

@Injectable({
	providedIn: "root"
})
export class UserEndpointService {
	private readonly dataService = inject(DataService);

	public getUser(): Observable<User> {
		return this.dataService
			.get<ClaimDto[]>(USER_ENDPOINT)
			.pipe(map((claims: ClaimDto[]) => mapClaimsDtoToUser(claims)));
	}

	public saveUserName(request: SaveUserRequestDto): Observable<void> {
		return this.dataService.put(USER_SAVE_NAME_ENDPOINT, request);
	}

	public getUserDetails(): Observable<UserProfileDto> {
		return this.dataService.get<UserProfileDto>(USER_PROFILE_ENDPOINT);
	}
}
